// 22.01.19 - The purpose of this component is simply to wrap all content that we display, so that
// all content is wrapped in the same root div(we use MUI's Paper). Used in route/index.tsx.
import { Paper, withStyles, WithStyles } from "@material-ui/core";
import * as React from "react";
import { generalStyles } from "src/styles/general";

type ContentWrapperProps = WithStyles<typeof generalStyles> & {
  children?: React.ReactNode;
};

export const ContentWrapper = withStyles(generalStyles)(
  (props: ContentWrapperProps) => {
    const { children, classes } = props;
    return <Paper className={classes.contentPadding}>{children}</Paper>;
  }
);
